<template>
  <responsive-modal v-model="visible">
    <div class="tool-modal-option p-6">
      <button class="btn text-secondary close" @click="visible = false">
        <i class="icon-x" />
      </button>
      <div><strong>Integração Active Campaign</strong></div>
      <small class="text-secondary my-5">
        <a
          target="_blank"
          href="https://www.activecampaign.com"
          class="text-primary font-weight-bold text-decoration-none"
        >
          Conheça o Active Campaign
        </a>
      </small>
      <hr />
      <form-group
        value="Active Campaign"
        id="name"
        label="Nome da conta"
        :errors="errors.name"
        disabled
      />
      <form-group
        id="description"
        label="Descrição da conta"
        placeholder="Digite a descrição da conta"
        v-model="form.description"
        :errors="errors.description"
      />
      <span class="small-text text-secondary">
        A descrição da conta ajuda na identificação interna, entre os produtos
        da Blitzpay.
      </span>
      <form-group
        v-model="form.url"
        id="url"
        label="API URL"
        placeholder="Digite a URL"
        :errors="errors.url"
      />
      <form-group
        v-model="form.token"
        id="token"
        label="API Key"
        placeholder="Digite a chave"
        :errors="errors.token"
      />

      <div class="text-center pt-5">
        <button
          class="btn btn-primary"
          :disabled="!isValid"
          :class="{
            'bg-secondary border-secondary': !isValid
          }"
          @click="submit"
        >
          <loading :show="loading">
            {{ editedProvider ? "Salvar" : "Integrar" }}
          </loading>
        </button>
      </div>
    </div>
  </responsive-modal>
</template>

<script>
import { formFields } from "../../../functions/helpers";

export default {
  props: {
    value: {
      type: Boolean,
      default: false
    },
    editedProvider: {
      type: Object,
      default: null
    }
  },
  data() {
    return {
      ...formFields(["name", "url", "token", "description"], {
        name: "active_campaign"
      }),
      visible: false,
      loading: false
    };
  },
  computed: {
    isValid() {
      return this.form.url && this.form.token && this.form.description;
    }
  },
  watch: {
    value(v) {
      this.visible = v;
    },
    visible(v) {
      this.$emit("input", v);
      if (!v) {
        this.clear();
      }
    },
    editedProvider(v) {
      if (v) {
        this.form = {
          ...v
        };
      }
    }
  },
  methods: {
    clear() {
      this.$emit("clear-edit");
      this.form = formFields(["name", "url", "token", "description"], {
        name: "active_campaign"
      });
    },
    submit() {
      let mistakeMsg = "";

      ["https://", ".com"].forEach(term => {
        if (this.form.url.indexOf(term) === -1) {
          mistakeMsg = "Digite uma url válida";
        }
      });

      if (mistakeMsg.length) {
        this.$message.error(mistakeMsg);
        return;
      }

      this.loading = true;

      let action = "integration/postProvider";
      let form = { ...this.form };
      if (this.editedProvider) {
        action = "integration/putProvider";
        form.id = this.editedProvider.id;
      }

      this.$store
        .dispatch(action, form)
        .then(() => {
          this.$message.success("Salvo com sucesso");
          this.visible = false;
          this.clear();
          this.$emit("refresh");
        })
        .catch(error => {
          let errorMsg = "Erro ao salvar";
          if (error.response?.data?.message) {
            errorMsg = error.response?.data?.message.split(".")[0];
          }
          this.$message.error(errorMsg);
        })
        .finally(() => {
          this.loading = false;
        });
    }
  }
};
</script>
<style lang="scss" scoped>
.tool-modal-option {
  position: relative;
  .close {
    position: absolute;
    top: 0;
    right: 0;
  }

  button {
    i {
      font-size: 28px;
    }
  }
}
</style>
